module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p0"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "hang "
  }, [_vm._v("The revelation of some uneasy secrets")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("would move most anything, even pigs and fishes,")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("to lift their heads and speak: and at such times")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("it furthers one to cross the great dark water")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("and learn the truth its silent shadows hide.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("In the wet, reedy evening, birdsong echoes,")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("old calling young, eventually answered;")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("while another stands in the dark and calls its fellow,")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("hearing for answer only the ancient silence")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("in which tears fall, under a moon near-full.")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("The lead horse breaks the traces and goes astray")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("to cry its clarion challenge harsh at heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("Understandably. But can it understand in time")]), _vm._v(" "), _c('p', {
    staticClass: "hang "
  }, [_vm._v("the danger that dogs immoderate success? . . .")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left indent3"
  }, [_c('em', [_vm._v("—hexagram 61")]), _c('br'), _vm._v("\n“"), _c('em', [_vm._v("a wind troubles the waters")]), _vm._v("”")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("If Time has a heart, it is because other hearts stop.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left indent3"
  }, [_c('em', [_vm._v("—Book of Night with Moon")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("9.v.IX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209e0827","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 66
// module chunks = 0